module.exports = __webpack_public_path__ + "img/9.13d72acc.jpg";